import { BaseApiService } from './BaseApiService';
import { sharedTokenRefresh } from './tokenRefresh';

export class WordApiService extends BaseApiService {
    constructor() {
        super(sharedTokenRefresh);
    }

    async generateCaseWord(caseId: string, docType: string, parameters?: Record<string, string | boolean | number | null>): Promise<{ blob: Blob; fileName: string }> {
        const requestBody: Record<string, unknown> = { caseId, docType };
        if (parameters && Object.keys(parameters).length > 0) {
            requestBody.parameters = parameters;
        }
        const response = await this.postJson('/v1/word/generate', requestBody);

        if (!response.ok) {
            let errorMessage = `HTTP error! status: ${response.status}`;
            try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorData.error || errorMessage;
            } catch { /* ignore */ }
            throw new Error(errorMessage);
        }

        const blob = await response.blob();
        let fileName = `case-${caseId}-${docType}.docx`;

        const contentDisposition = response.headers.get('Content-Disposition');
        if (contentDisposition) {
            const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (match?.[1]) {
                fileName = match[1].replace(/^['"]|['"]$/g, '').trim();
                try { fileName = decodeURIComponent(fileName); } catch { /* ignore */ }
            }
        }

        return { blob, fileName };
    }

    downloadWord(blob: Blob, fileName: string): void {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }
}

export const wordApiService = new WordApiService();
